import React, { useEffect, useMemo, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Form,
  InputGroup,
  Accordion,
} from "react-bootstrap";
import {
  EntypoPlus,
  EntypoMinus,
  EntypoShoppingCart,
  EntypoMagnifyingGlass,
  EntypoInfo,
  EntypoWarning,
} from "react-entypo-icons";
import "./RestaurantFoodSelection.css";
import { primaryColor } from "../../config/colors";
import RestaurantFoodItemDetailDialog from "./RestaurantFoodItemDetailDialog";
import { strings } from "../../localization";
import {
  formateNumber,
  getFoodDataFromStorage,
  getOrganisationId,
  getTotalPriceOfFoodItem,
  navigatePage,
  ROUTE_PREFIX,
  setFoodDataInStorage,
} from "../../config";
import Loading from "../../components/Loading";
import CustomNavbar from "../../components/navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import { withRouter } from "react-router-dom";
import { getFoodCategory } from "../../api/ApiServices";
import EmptyOrderComponent from "../../components/EmptyOrderComponent";

function RestaurantFoodSelection({ match, location }) {
  const { restaurantName } = match.params || {};
  const [search, setSearch] = useState("");
  const [showFoodDetailDialog, setShowFoodDetailDialog] = useState(false);
  const [foodList, setFoodList] = useState([]);
  const [selectedFoodItem, setSelectedFoodItem] = useState("");
  const [selectedCategoryId, setSelectedCategoryId] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const manageItemQuantity = (categoryId, id, isItemQtyIncrement) => {
    const oldFoodList = [...foodList];
    const matchedCategory = oldFoodList.find(
      (foodItem) => foodItem._id == categoryId
    );
    console.log("matched category :", matchedCategory);
    if (matchedCategory) {
      const foodItems = matchedCategory.items;
      console.log("foodItems", foodItems);
      const matchedFoodItem = foodItems.find(
        (foodItem) => foodItem.itemID === id
      );
      if (matchedFoodItem) {
        console.log("matchedFoodItem : ", matchedFoodItem);
        let parsedQty = parseInt(matchedFoodItem.quantity) || 0;
        if (isItemQtyIncrement) {
          parsedQty++;
        } else {
          parsedQty--;
        }
        matchedFoodItem.quantity = parsedQty.toString();
      }
      console.log("old food list in manageItemQuantity", oldFoodList);
      setFoodList(oldFoodList);
    }
  };

  const handleQtyInputChanges = (categoryId, id, qty) => {
    const oldFoodList = [...foodList];
    const matchedCategory = oldFoodList.find(
      (foodItem) => foodItem._id == categoryId
    );
    if (matchedCategory) {
      const foodItems = matchedCategory.items;
      const matchedFoodItem = foodItems.find(
        (foodItem) => foodItem.itemID === id
      );
      if (matchedFoodItem) {
        let parsedQty = parseInt(qty) || 0;
        matchedFoodItem.quantity = parsedQty.toString();
      }
      setFoodList(oldFoodList);
    }
  };

  const getTotalPrice = () => {
    console.log("food List in total price function : ", foodList);
    const totalPrice = foodList.reduce((categoryAcc, category) => {
      return (
        categoryAcc +
        category.items.reduce(
          (itemAcc, item) => itemAcc + item.price * parseFloat(item.quantity),
          0
        )
      );
    }, 0);
    console.log("total price", totalPrice);
    return totalPrice;
  };

  const getTotalItems = () => {
    console.log("food List", foodList);
    const totalItems = foodList.reduce((categoryAcc, category) => {
      console.log("category", category);
      return (
        categoryAcc +
        category.items.reduce(
          (itemAcc, item) => itemAcc + Number(item.quantity),
          0
        )
      );
    }, 0);
    return totalItems;
  };

  const onConfirmPressed = (item, categoryId) => {
    const oldFoodList = [...foodList];
    const matchedCategory = oldFoodList.find(
      (foodItem) => foodItem._id == categoryId
    );
    if (matchedCategory) {
      const foodItems = matchedCategory.items;
      const matchedFoodItem = foodItems.find(
        (foodItem) => foodItem.itemID === item.itemID
      );
      if (matchedFoodItem) {
        matchedFoodItem.quantity = item.quantity || 0;
        matchedFoodItem.note = item.note || "";
      }
      setFoodList(oldFoodList);
      setShowFoodDetailDialog(false);
    }
  };

  const onViewCartButtonClicked = () => {
    const filteredFoodData = foodList
      .map((category) => {
        const filteredItems = category.items.filter(
          (item) => Number(item.quantity) > 0
        );
        return {
          ...category,
          items: filteredItems,
        };
      })
      .filter((category) => category.items.length > 0);

    setFoodDataInStorage(filteredFoodData);
    navigatePage(`/${ROUTE_PREFIX}${restaurantName}/order-summary`);
  };

  const getFoodItemsCategory = () => {
    setIsLoading(true);
    const parsedFoodItems = JSON.parse(getFoodDataFromStorage());
    console.log("DEV-100 parsedFoodItems", parsedFoodItems);
    const organisationID = getOrganisationId()
    // Change this to dynamic once ready
    getFoodCategory(organisationID)
      .then(async (res) => {
        const parsedJson = await res.json();
        console.log("parsed json", parsedJson);
        console.log("parsed json", Array.isArray(parsedJson));
        if (res.status === 200) {
          if (parsedJson && Array.isArray(parsedJson)) {
            let result = parsedJson.map((group) => ({
              ...group,
              items: group.items.map((item) => ({
                ...item,
                quantity: "0",
                note: "",
              })),
            }));
            if (parsedFoodItems && parsedFoodItems.length > 0) {
              console.log("DEV-100 in if condition");
              result = result.map((category) => {
                const matchingCategory = parsedFoodItems.find(
                  (addedCategory) => addedCategory._id === category._id
                );
                console.log("DEV-100 matchingCategory", matchingCategory);
                const updatedItems = category.items.map((item) => {
                  if (!matchingCategory) return item;

                  const addedItem = matchingCategory.items.find(
                    (added) => added.itemID === item.itemID
                  );

                  if (addedItem) {
                    return {
                      ...item,
                      quantity: addedItem.quantity,
                      note: addedItem.note,
                    };
                  }
                  return item;
                });
                console.log("DEV-100 updatedItems", updatedItems);

                return {
                  ...category,
                  items: updatedItems,
                };
              });
            }
            console.log("DEV-100 result", result);
            setFoodList(result);
          }
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log("catch block error while getting food category", err);
        setIsLoading(false);
      });
  };

  const filterFoodItems = (foodItems, searchQuery) => {
    const query = searchQuery.trim().toLowerCase();

    if (query === "") return foodItems;

    return foodItems
      .map((category) => {
        const matchedCategoryName = category.name.toLowerCase().includes(query);

        const filteredItems = category.items.filter(
          (item) =>
            item.name.toLowerCase().includes(query) ||
            item.description.toLowerCase().includes(query)
        );

        if (matchedCategoryName || filteredItems.length > 0) {
          return {
            ...category,
            items:
              matchedCategoryName && filteredItems.length === 0
                ? category.items
                : filteredItems,
          };
        }

        return null;
      })
      .filter(Boolean);
  };

  const filteredCategories = useMemo(() => {
    console.log("DEBUG foodList in categories", foodList);
    return filterFoodItems(foodList, search);
  }, [foodList, search]);

  useEffect(() => {
    getFoodItemsCategory();
  }, []);

  return (
    <div className="d-flex flex-column vh-100 overflow-hidden">
      {/* Header Section */}
      <Container fluid className="sticky-top shadow-sm">
        <CustomNavbar pageName={strings.select_food} />
        <div style={{ backgroundColor: primaryColor }}>
          <InputGroup className="px-2 pb-2 py-2">
            <InputGroup.Text>
              <EntypoMagnifyingGlass />
            </InputGroup.Text>
            <Form.Control
              placeholder={`${strings.search_for_food}...`}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{ border: 0 }}
            />
          </InputGroup>
        </div>
      </Container>

      {isLoading ? (
        <Loading />
      ) : (
        <div
          className="flex-grow-1 foodItemsContainer"
          style={{
            maxHeight: `calc(${
              getTotalItems() > 0 ? "93vh" : "100vh"
            } - 150px)`,
            overflowY: "auto",
            overflowX: "hidden",
          }}
        >
          {foodList.length === 0 ? (
            <div className="text-center text-muted my-4">
              <EmptyOrderComponent
                title={strings.empty_food_data_msg}
              />
            </div>
          ) : filteredCategories.length === 0 ? (
            <div className="text-center text-muted my-4">
              <EntypoMagnifyingGlass
                className="mb-2"
                style={{ fontSize: 25 }}
              />
              <div>{strings.no_food_item_seach_found_msg}</div>
            </div>
          ) : (
            filteredCategories.map((foodItem, index) => {
              if (foodItem.items && foodItem.items.length > 0) {
                return (
                  <Accordion style={{ marginTop: 10 }}>
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>{foodItem.name}</Accordion.Header>
                      <Accordion.Body className="p-0">
                        <div>
                          <Row>
                            {foodItem.items.map((item) => (
                              <Col
                                xs={6}
                                sm={6}
                                md={4}
                                key={item.itemID}
                                className="foodItemCard p-0"
                              >
                                <Card
                                  className="foodSelectionCardContainer h-100"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setSelectedFoodItem(item);
                                    setSelectedCategoryId(foodItem._id);
                                    setShowFoodDetailDialog(true);
                                  }}
                                >
                                  <Card.Body className="px-4 py-3">
                                    <div className="foodItemCardBodyContentContainer">
                                      {/* LEFT: Food Info */}
                                      <div style={{ flex: 1, minWidth: 0 }}>
                                        <Card.Title
                                          className="fw-bold mb-1 truncate-multiline"
                                          style={{
                                            fontSize: 15,
                                            lineHeight: "1.2rem",
                                            color: "#222222",
                                          }}
                                        >
                                          {item.name}
                                        </Card.Title>
                                        <Card.Text
                                          className="mb-1 truncate-threeline"
                                          style={{ fontSize: 12 }}
                                        >
                                          {item.description}
                                        </Card.Text>

                                        {item.note ? (
                                          <div className="d-flex flex-column">
                                            <p
                                              style={{
                                                fontSize: 12,
                                                textDecoration: "underline",
                                                cursor: "pointer",
                                                marginBottom: 5
                                              }}
                                            >
                                              {strings.edit_note}:{" "}
                                            </p>
                                            <p
                                              className="truncate-multiline"
                                              style={{
                                                textDecoration: "none",
                                                fontSize: 12,
                                                width: "100%",
                                                marginBottom: 5
                                              }}
                                            >
                                              {item.note}
                                            </p>
                                          </div>
                                        ) : (
                                          <p
                                            style={{
                                              fontSize: 12,
                                              textDecoration: "underline",
                                              textDecorationColor: primaryColor,
                                              cursor: "pointer",
                                            }}
                                          >
                                            {strings.add_note}
                                          </p>
                                        )}
                                      </div>

                                      <div className="foodItemPriceQtyContainer">
                                        <h5
                                          className="my-2 p-0"
                                          style={{
                                            color: primaryColor,
                                            fontSize: 16,
                                          }}
                                        >
                                          {/* {formateNumber(item.price)} */}
                                          {getTotalPriceOfFoodItem(
                                            item.price,
                                            item.quantity
                                          )}
                                        </h5>
                                        {item.quantity &&
                                        item.quantity > "0" ? (
                                          <div
                                            className="d-flex align-items-center border rounded-pill px-2 py-1 bg-white"
                                            style={{ flexShrink: 0 }}
                                          >
                                            <Button
                                              variant="link"
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                manageItemQuantity(
                                                  foodItem._id,
                                                  item.itemID,
                                                  false
                                                );
                                              }}
                                              className="p-0 fw-bold"
                                              style={{
                                                border: "none",
                                                boxShadow: "none",
                                                color: primaryColor,
                                              }}
                                            >
                                              <EntypoMinus />
                                            </Button>

                                            <Form.Control
                                              type="number"
                                              value={item.quantity}
                                              onClick={(e) => {
                                                e.stopPropagation();
                                              }}
                                              onChange={(e) => {
                                                e.stopPropagation();
                                                const value = parseInt(
                                                  e.target.value,
                                                  10
                                                );
                                                if (
                                                  !isNaN(value) &&
                                                  value > 0
                                                ) {
                                                  handleQtyInputChanges(
                                                    foodItem._id,
                                                    item.itemID,
                                                    value
                                                  );
                                                }
                                              }}
                                              min="1"
                                              className="mx-2 text-center no-spinner fw-bold"
                                              style={{
                                                width: "50px",
                                                border: "none",
                                                backgroundColor: primaryColor,
                                                color: "white",
                                                borderRadius: "8px",
                                                padding: "2px 6px",
                                              }}
                                            />

                                            <Button
                                              variant="link"
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                manageItemQuantity(
                                                  foodItem._id,
                                                  item.itemID,
                                                  true
                                                );
                                              }}
                                              className="p-0 fw-bold"
                                              style={{
                                                border: "none",
                                                boxShadow: "none",
                                                color: primaryColor,
                                              }}
                                            >
                                              <EntypoPlus />
                                            </Button>
                                          </div>
                                        ) : (
                                          <div
                                            className="d-flex align-items-center border rounded-pill px-4 py-2"
                                            style={{
                                              flexShrink: 0,
                                              color: "white",
                                              cursor: "pointer",
                                              backgroundColor: primaryColor,
                                            }}
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              manageItemQuantity(
                                                foodItem._id,
                                                item.itemID,
                                                true
                                              );
                                            }}
                                          >
                                            <Button
                                              variant="link"
                                              className="p-0 d-flex align-items-center text-decoration-none"
                                              style={{
                                                color: "white",
                                                fontSize: 12,
                                                fontWeight: "bold",
                                              }}
                                            >
                                              <span>
                                                {strings.add_item.toUpperCase()}
                                              </span>
                                            </Button>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </Card.Body>
                                </Card>
                              </Col>
                            ))}
                          </Row>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                );
              }
            })
          )}
        </div>
      )}

      {getTotalItems() > 0 && (
        <div className="viewCart">
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <EntypoShoppingCart className="me-2" />
              {getTotalItems()} {strings.items} | {formateNumber(getTotalPrice())}
            </div>
            <Button variant="primary" onClick={onViewCartButtonClicked}>
              {strings.view_cart}
            </Button>
          </div>
        </div>
      )}
      {showFoodDetailDialog && (
        <RestaurantFoodItemDetailDialog
          setShowModal={setShowFoodDetailDialog}
          showModal={showFoodDetailDialog}
          foodItem={selectedFoodItem}
          onConfirmPressed={onConfirmPressed}
          categoryId={selectedCategoryId}
        />
      )}
      <Footer />
    </div>
  );
}

export default withRouter(RestaurantFoodSelection);
